import { actions } from './actions'

const initialState = {
  roles: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function usuarioReducer(state = initialState, action) {
  switch (action.type) {
    case actions.ROLES_LOAD_REQUESTED:
      return { ...state, roles: { ...state.roles, loading: true } }
    case actions.ROLES_LOAD_SUCCEEDED:
      return {
        ...state,
        roles: { ...state.roles, data: action.payload, loading: false },
      }
    case actions.ROLES_LOAD_FAILED:
      return {
        ...state,
        roles: { ...state.roles, loading: false, error: action.error },
      }

    default:
      return state
  }
}
